import * as React from 'react';
import styled from 'styled-components';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box } from '@mui/material';
import { CalenderIcon } from '../Icons';
import dayjs from 'dayjs';
import customParseFormatPlugin from 'dayjs/plugin/customParseFormat';
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const StyledLabel = styled(Box)`
	color: var(--color-font-grey);
	font-size: 16px;
	font-weight: 600;
	line-height: 15.6px;
	margin-bottom: 5px;
`;

const StyledDatePicker = styled(DatePicker)<{
	inputError: string | undefined;
	styles: React.CSSProperties | undefined;
}>`
	height: ${(props) => (props.styles?.height ? props.styles.height : '36px')};
	width: ${(props) => (props.styles?.width ? props.styles.width : '300px')};
	input {
		position: relative;
		border: none;
		outline: none;
		box-sizing: border-box;
		background-color: #fff;
		display: flex;
		padding-left: 10px;
		align-items: center;
	}

	& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
		border: 1.5px solid ${(props) => (props.inputError ? 'red' : '#e9e9e9')};
		border-radius: 4px;
	}

	&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
		border: 1.5px solid #acacac;
		border-radius: 4px;
	}

	&.Mui-focused .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
		border: 1.5px solid #acacac;
		border-radius: 4px;
	}
`;

type Props = {
	label?: string;
	inputError?: string | undefined;
	styles?: React.CSSProperties;
	value?: any;
	slots?: any;
	selectedDate?: Date | string | null;
	minDate?: Date | string | null;
	onDateChange: (date: Date | null) => void;
	disabled?: boolean;
	labelStyles?: any;
};

const LabeledDatePicker: React.FC<Props> = ({
	label,
	inputError,
	styles,
	disabled,
	labelStyles,
	...props
}) => (
	<div style={{ display: 'flex', flexDirection: 'column', marginTop: '6px' }}>
		<StyledLabel style={labelStyles}>{label}</StyledLabel>
		<StyledDatePicker inputError={inputError} styles={styles} {...props} disabled={disabled} />
	</div>
);

// dayjs.extend(customParseFormatPlugin);
// dayjs.extend(localizedFormatPlugin);
// dayjs.extend(isBetweenPlugin);
dayjs.extend(utc);
dayjs.extend(timezone);

const CustomDatePicker: React.FC<Props> = ({
	label,
	inputError,
	styles = {},
	selectedDate,
	onDateChange,
	minDate = null,
	disabled = false,
	labelStyles = {},
}) => {
	const dayjsSelectedDate = selectedDate ? dayjs.utc(selectedDate) : null;
	const dayjsMinDate = minDate ? dayjs.utc(minDate) : null;

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<LabeledDatePicker
				label={label}
				inputError={inputError}
				styles={styles}
				value={dayjsSelectedDate}
				//@ts-ignore
				minDate={dayjsMinDate}
				format="DD-MMMM-YYYY"
				onChange={onDateChange}
				slots={{
					openPickerIcon: CalenderIcon,
				}}
				disabled={disabled}
				labelStyles={labelStyles}
				timezone="Asia/Kolkata"
			/>
		</LocalizationProvider>
	);
};

export default CustomDatePicker;
